import { ELightType } from '@seddi/scene';
import { DirectionalLight, Light, Object3D, PointLight, RectAreaLight } from '@seddi/three';
import { create as createObject, removeFromParent } from '../three/core/object3d';

export interface LightRenderable {
  light: Light;
  lightTarget?: Object3D;
}

export const create = (id: string, node: Object3D, type: ELightType): LightRenderable => {
  let light: Light;
  let lightTarget: Object3D;

  switch (type) {
    case ELightType.Area:
      light = new RectAreaLight();
      break;
    case ELightType.Directional: {
      const pair = createDirectional(id, node);
      light = pair.light;
      lightTarget = pair.lightTarget;
      break;
    }
    case ELightType.Point:
    default:
      light = new PointLight();
      break;
  }

  light.name = id + '-light';
  node.add(light);

  return { light, lightTarget };
};

/**
 * Dispose renderable.
 * @param renderable - Renderable.
 */
export const dispose = (renderable: LightRenderable) => {
  if (renderable.lightTarget) {
    renderable.lightTarget.parent.remove(renderable.lightTarget);
  }
  renderable.light.dispose();
  renderable.light.parent.remove(renderable.light);
};

/**
 * Create directional.
 * @param parent - Parent node.
 */
const createDirectional = (id: string, node: Object3D): { light: Light; lightTarget: Object3D } => {
  const light = new DirectionalLight();
  light.shadow.camera.top = 5;
  light.shadow.camera.bottom = -5;
  light.shadow.camera.left = -5;
  light.shadow.camera.right = 5;
  light.shadow.mapSize.width = 2048;
  light.shadow.mapSize.height = 2048;

  // LookAt target
  light.position.set(0, 0, 0);
  light.updateMatrix();

  const lightTarget = createObject(id + '-lightt', node);
  lightTarget.position.set(0, 0, -1);
  lightTarget.updateMatrix();
  light.target = lightTarget;

  return { light, lightTarget };
};
